/**
 * Exact menu structure from scrape manifest (eeskole.dk | scrape-1790925526715)
 * Strict fidelity: same labels, same hierarchy, same item count.
 */

export const MENU_ITEMS = [
  {
    label: 'Forside',
    href: '/',
    children: []
  },
  {
    label: 'Ordblindeefterskole',
    href: '/ordblindeefterskole',
    children: [
      { label: 'Når dit barn har DLD', href: '/dld' },
      { label: 'Når dit barn har APD', href: '/apd' },
      { label: 'Skolevægring', href: '/skolevaegring' },
      { label: 'Efterskole i 8. klasse', href: '/efterskole-i-8-klasse' },
      { label: 'Efterskole i 9. klasse', href: '/efterskole-i-9-klasse' },
      { label: 'Efterskole i 10. klasse', href: '/efterskole-i-10-klasse' },
    ]
  },
  {
    label: 'Undervisning',
    href: '/undervisning',
    children: [
      {
        label: 'Valgfag',
        href: '/undervisning/valgfag',
        children: [
          { label: 'Oversigt over valgfag', href: '/undervisning/valgfag' },
          { label: 'KREA', href: '/undervisning/valgfag/krea' },
          { label: 'Fitness', href: '/undervisning/valgfag/fitness' },
          { label: 'Spring', href: '/undervisning/valgfag/spring' },
          { label: 'Mindfulness', href: '/undervisning/valgfag/mindfulness' },
          { label: 'Mediefag', href: '/undervisning/valgfag/mediefag' },
          { label: 'Cykling', href: '/undervisning/valgfag/cykling' },
          { label: 'Musik', href: '/undervisning/valgfag/musik' },
          { label: 'Selvforsvar', href: '/undervisning/valgfag/selvforsvar' },
        ]
      },
      {
        label: 'Fag',
        href: '/undervisning/fag',
        children: [
          { label: 'Dansk', href: '/undervisning-i-dansk' },
          { label: 'Matematik', href: '/undervisning-i-matematik' },
          { label: 'Biologi', href: '/undervisning-i-biologi' },
          { label: 'Engelsk', href: '/undervisning-i-engelsk' },
          { label: 'Fysik & kemi', href: '/undervisning-i-fysik-kemi' },
          { label: 'Geografi', href: '/undervisning-i-geografi' },
          { label: 'Idræt', href: '/undervisning-i-idraet' },
          { label: 'Historie', href: '/undervisning-i-historie' },
          { label: 'Samfundsfag', href: '/undervisning-i-samfundsfag' },
          { label: 'Kristendom', href: '/undervisning-i-kristendom' },
          { label: 'Tysk', href: '/undervisning-i-tysk' },
        ]
      },
      { label: 'Brobygning', href: '/undervisning/brobygning' },
      { label: 'Juniormesterlære', href: '/undervisning/juniormesterlaere' },
      { label: 'Tekniske hjælpemidler', href: '/undervisning/tekniske-hjaelpemidler' },
    ]
  },
  {
    label: 'Hverdagen',
    href: '/hverdagen',
    children: []
  },
  {
    label: 'Om os',
    href: '/om-os',
    children: [
      { label: 'Når dit barn har DLD', href: '/dld' },
      { label: 'Når dit barn har APD', href: '/apd' },
      { label: 'Trivselsefterskole', href: '/specialefterskole' },
      { label: 'Faciliteter', href: '/faciliteter' },
      { label: 'Personalet', href: '/personalet' },
      { label: 'Kostpolitik', href: '/om-os/kostpolitik' },
      { label: 'Bestyrelsen', href: '/om-os/bestyrelsen' },
      { label: 'Økonomi', href: '/om-os/oekonomi' },
      { label: 'Job', href: '/om-os/job-paa-emmerske-efterskole' },
      { label: 'Billeder', href: '/billeder' },
      { label: 'Værd at vide', href: 'https://eeskole.dk/sites/default/files/2025-07/vaerd_at_vide_25-26.pdf', external: true },
      { label: 'Kalender', href: 'https://eeskole.dk/sites/default/files/2025-11/Skolea%CC%8Ar%2025%20-%2026%20kalender.pdf', external: true },
      { label: 'Emmerskes historie', href: '/om-os/emmerskes-historie' },
    ]
  },
  {
    label: 'Lovkrav',
    href: '/lovkrav',
    children: []
  },
  {
    label: 'Skolekreds',
    href: '/skolekreds',
    children: []
  },
  {
    label: 'VIGGO',
    href: 'https://eeskole.viggo.dk/Basic/Account/Login?returnUrl=%2F',
    external: true,
    children: []
  },
  {
    label: 'Book rundvisning',
    href: '/rundvisning',
    isCta: true,
    children: []
  },
  {
    label: 'Webshop',
    href: 'https://toender.sport24klubshops.dk/shop/emmerske-efterskole-27c1.html',
    external: true,
    children: []
  },
  {
    label: 'Efterskolernes Dag 2026',
    href: 'https://qvisty.github.io/emmerske-radio/',
    external: true,
    children: []
  }
]
